
import { Fraga } from "@/types/riskbedomning";

export const constructionRiskFragor: Fraga[] = [
  {
    id: "tunga-element",
    text: "Finns det risk att arbete med lansering, montering eller nedmontering av tunga byggelement eller tunga formbyggnadselement utförs?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att lyftområdet inte är avspärrat för att skydda obehöriga?",
      "Finns det risk att element faller eller välter under monteringen?"
    ]
  },
  {
    id: "rivning-konstruktioner",
    text: "Finns det risk att rivning av bärande konstruktioner, eller hälsofarliga material eller ämnen utförs?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Saknas förundersökning (asbest/PCB/bly/kvarts/härdplaster), metod/turordning/plan/ventilation/dammåtgärder?",
      "Finns risk att damm/buller/vibrationer inte hanteras vid rivning/blästring/bilning?",
      "Finns det risk att rivningssekvensen inte är planerad så att strukturer kollapsar?",
      "Finns det risk att valda arbetsmetoder skapar onödig dammbildning?"
    ]
  }
];
